export default "__VITE_ASSET__iKpxL$VS__"